import { Dispatch, SetStateAction } from "react";
import {
  checkIfInputIsAnArrayWithValues,
  executeAllClauseFunctions,
  getToast,
} from "../../../common/utils";
import {
  enableDisableEntireVerticalURL,
  getClauseCheckListForSelectedVertical,
  getVerticalList,
} from "../../../services/common.service";
import {
  listContractReviewClauseManagement,
  listTalkToContractClauseManagement,
  addClauseCheckDetails,
  saveContractReviewClauseManagement,
  saveTalkToContractClauseManagement,
  enableDisableClauseCheckDetails,
  addImportClauseCheckDetails,
  addImportContractReviewDetails,
  createContractReviewClause,
} from "../admin.service";
import {
  adminClauseCheckConstants,
  defaultClauseStatus,
  PromptsForFeature,
} from "../constants";
import {
  PromptModel,
  PromptModelForVerticalList,
  PromptModelForContractReview,
  PromptModelForClauseCheckData,
} from "../model";
import {
  getClauseItemsForContractReview,
  getClauseItemsForTTC,
  getRuleForSavingForContractReview,
  getRuleForSavingForTTC,
} from "../util";
import {
  EnableDisableClauseCheckPayloadinterface,
  EnableDisableModalStateinterface,
  selectedSubClauseInterface,
} from "../../../types/AdminClauseCheckTypes";
import { setVerticalForKeyClauseDashboard } from "../../../store/thunks/common.thunk";
import { isUndefined } from "underscore";
import { LOCAL_STORAGE_KEYS } from "../../../common/constants";

export const ADMIN_ACTIONS = {
  GET_PROMPTS: "GET_PROMPTS",
  UPDATE_CLAUSE: "UPDATE_CLAUSE",
  ADD_NEW_KEYWORD_SECTION_FOR_TTC: "ADD_NEW_KEYWORD_SECTION_FOR_TTC",
  SAVE_NEW_SYNONYM_FOR_TTC: "SAVE_NEW_SYNONYM_FOR_TTC",
  DELETE_KEYWORD_SECTION_FOR_TTC: "DELETE_KEYWORD_SECTION_FOR_TTC",
  REMOVE_KEYWORDS_WITH_NEW_KEYWORD_TYPE:
    "REMOVE_KEYWORDS_WITH_NEW_KEYWORD_TYPE",
  SET_ROLE_MANAGE_DATA: "SET_ROLE_MANAGE_DATA",
  GET_VERTICAL_LIST_DATA: "GET_VERTICAL_LIST_DATA",
  ADD_NEW_CLAUSE_CHECK: "ADD_NEW_CLAUSE_CHECK",
  GET_CLAUSE_CHECK_SUMMARY: "GET_CLAUSE_CHECK_SUMMARY",
  GET_CLAUSE_CHECK_SUMMARY_FOR_CONTRACT_REVIEW:
    "GET_CLAUSE_CHECK_SUMMARY_FOR_CONTRACT_REVIEW",
  GET_IMPORT_CLAUSE_CHECK_SUMMARY: "GET_IMPORT_CLAUSE_CHECK_SUMMARY",
  GET_CONTRACT_REVIEW_IMPORT_CLAUSE_CHECK_LIST:
    "GET_CONTRACT_REVIEW_IMPORT_CLAUSE_CHECK_LIST",
  ENABLE_DISABLE_VERTICAL: "ENABLE_DISABLE_VERTICAL",
  SELECTED_VERTICAL: "SELECTED_VERTICAL",
};

const promptManagement = {
  [PromptsForFeature.CLAUSE_CHECK_TAB.CLAUSE_CHECK_VERTICAL_LIST]: {
    api: getVerticalList,
    model: PromptModelForVerticalList,
    sanitizer: [],
  },
  [PromptsForFeature.CLAUSE_CHECK_TAB.CLAUSE_CHECK_VERTICAL_ADVANCED_LIST]: {
    api: getVerticalList,
    model: PromptModelForVerticalList,
    sanitizer: [],
  },
  [PromptsForFeature.CONTRACT_REDLINING]: {
    api: getVerticalList,
    model: PromptModelForVerticalList,
    sanitizer: [],
  },
  [PromptsForFeature.CONTRACT_EXECUTION]: {
    api: getVerticalList,
    model: PromptModelForVerticalList,
    sanitizer: [],
  },
  [PromptsForFeature.CONTRACT_EXPIRY]: {
    api: getVerticalList,
    model: PromptModelForVerticalList,
    sanitizer: [],
  },
  [PromptsForFeature.CLAUSE_CHECK_TAB.ENABLE_DISABLE_CHECK_VERTICAL_LIST]: {
    api: enableDisableEntireVerticalURL,
    model: PromptModelForVerticalList,
    sanitizer: [],
  },
  [PromptsForFeature.CONTRACT_REVIEW_TAB.CONTRACT_REVIEW_CLAUSE_CHECK_LIST]: {
    api: listContractReviewClauseManagement,
    model: PromptModelForContractReview,
    sanitizer: getClauseItemsForContractReview,
  },
  [PromptsForFeature.TALK_TO_CONTRACT]: {
    api: getVerticalList,
    model: PromptModelForVerticalList,
    sanitizer: [],
  },
};

export const getPrompts = ({ feature }: { feature: string }) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: ADMIN_ACTIONS.GET_PROMPTS,
        payload: {
          feature: feature,
          data: {
            loading: true,
            error: {},
          },
        },
      });

      const api = promptManagement?.[feature]?.api;
      let res = null;
      if (!api) return;

      res = await api({
        filter_is_enabled: undefined,
        verticalId: "",
        feature: feature,
        enable_count_feature: undefined,
      } as any);
      const Model = promptManagement?.[feature]?.model;
      let data = null;
      if (!Model) return;

      const sanitizer = promptManagement?.[feature]?.sanitizer;
      data = res?.clauses?.map(
        (res: any) => new Model({ ...res, sanitizer: sanitizer })
      );

      dispatch({
        type: ADMIN_ACTIONS.GET_PROMPTS,
        payload: {
          feature: feature,
          data: {
            data: data,
            loading: false,
            error: {},
          },
        },
      });
    } catch (error) {
      dispatch({
        type: ADMIN_ACTIONS.GET_PROMPTS,
        payload: {
          feature: feature,
          data: {
            loading: false,
            error: error,
          },
        },
      });
    }
  };
};

export const getVerticalListData = ({
  feature,
  filter_is_enabled,
  isFrom,
  enable_count_feature,
}: {
  feature: string;
  filter_is_enabled?: boolean;
  isFrom?: string;
  enable_count_feature?: string;
}) => {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch({
        type: ADMIN_ACTIONS.GET_VERTICAL_LIST_DATA,
        payload: {
          feature: feature,
          data: {
            loading: true,
            error: {},
          },
        },
      });

      const api = promptManagement?.[feature]?.api;
      let res = null;
      if (!api) return;

      res = await api({
        filter_is_enabled: !!filter_is_enabled,
        verticalId: "",
        feature,
        enable_count_feature,
      } as any);
      const Model = promptManagement?.[feature]?.model;
      if (!Model) return;

      const sanitizer = promptManagement?.[feature]?.sanitizer;
      const data = new Model({ ...res, sanitizer: sanitizer }) as any;

      dispatch({
        type: ADMIN_ACTIONS.GET_VERTICAL_LIST_DATA,
        payload: {
          feature: feature,
          data: {
            data: data,
            loading: false,
            error: {},
          },
        },
      });

      const isVerticalSelected =
        getState()?.rootReducer?.commonReducer?.verticals?.[feature]?.label;

      const selectedVertical = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_KEYS.VERTICALS) || "{}"
      )?.[feature];

      const verticalsForFeature = data?.results
        ?.filter((vertical: any) => filterEnabledFeature?.[feature]?.(vertical))
        .map((vertical: any) => vertical?.id);

      // Check if Engineering vertical exists in the enabled verticals
      const engineeringVertical = data?.results?.find(
        (vertical: any) => 
          vertical?.name?.toLowerCase() === "engineering" && 
          filterEnabledFeature?.[feature]?.(vertical)
      );

      // If Engineering exists and is enabled, always use it as default (override localStorage)
      if (engineeringVertical) {
        const engineeringDefault = {
          label: engineeringVertical.name,
          value: engineeringVertical.id,
        };
        
        const featuresToDispatch =
          isFrom === "verticalManagement"
            ? [
                feature,
                PromptsForFeature.CONTRACT_REDLINING,
                PromptsForFeature.CONTRACT_EXPIRY,
                PromptsForFeature.TALK_TO_CONTRACT,
              ]
            : [feature];

        featuresToDispatch.forEach((feat) =>
          dispatch(setVerticalForKeyClauseDashboard(feat, engineeringDefault))
        );
      } else if (
        selectedVertical?.label &&
        verticalsForFeature?.includes(selectedVertical?.value)
      ) {
        const featuresToDispatch =
          isFrom === "verticalManagement"
            ? [
                feature,
                PromptsForFeature.CONTRACT_REDLINING,
                PromptsForFeature.CONTRACT_EXPIRY,
                PromptsForFeature.TALK_TO_CONTRACT,
              ]
            : [feature];

        featuresToDispatch.forEach((feat) =>
          dispatch(setVerticalForKeyClauseDashboard(feat, selectedVertical))
        );
      } else if (isVerticalSelected === "" || isUndefined(isVerticalSelected)) {
        await handleVerticalSelection(data, feature, dispatch, isFrom);
      }
    } catch (error) {
      dispatch({
        type: ADMIN_ACTIONS.GET_VERTICAL_LIST_DATA,
        payload: {
          feature: feature,
          data: {
            loading: false,
            error: error,
          },
        },
      });
    }
  };
};

const filterEnabledFeature = {
  [PromptsForFeature.CLAUSE_CHECK_TAB.CLAUSE_CHECK_VERTICAL_LIST]: (
    vertical: any
  ) => {
    return vertical?.is_enabled && vertical?.enabled_count?.clause_check > 0;
  },
  [PromptsForFeature.CLAUSE_CHECK_TAB.CLAUSE_CHECK_VERTICAL_ADVANCED_LIST]: (
    vertical: any
  ) => {
    return vertical?.is_enabled && vertical?.enabled_count?.clause_check > 0;
  },
  [PromptsForFeature.CONTRACT_REDLINING]: (vertical: any) => {
    return vertical?.is_enabled && vertical?.enabled_count?.redlining > 0;
  },
  [PromptsForFeature.CONTRACT_EXECUTION]: (vertical: any) => {
    return vertical?.is_enabled;
  },
  [PromptsForFeature.CONTRACT_EXPIRY]: (vertical: any) => {
    return vertical?.is_enabled;
  },
  [PromptsForFeature.TALK_TO_CONTRACT]: (vertical: any) => {
    return vertical?.is_enabled;
  },
};

const handleVerticalSelection = async (
  data: any,
  feature: string,
  dispatch: any,
  isFrom?: string
) => {
  let defaultVal = {
    label: "",
    value: "",
  };
  if (!checkIfInputIsAnArrayWithValues(data?.results)) {
    dispatch(setVerticalForKeyClauseDashboard(feature, defaultVal));
    return;
  }

  const featuresToDispatch =
    isFrom === "verticalManagement"
      ? [
          feature,
          PromptsForFeature.CONTRACT_REDLINING,
          PromptsForFeature.CONTRACT_EXPIRY,
          PromptsForFeature.TALK_TO_CONTRACT,
        ]
      : [feature];

  for (const feat of featuresToDispatch) {
    const results = data?.results?.filter((vertical: any) =>
      filterEnabledFeature?.[feat]?.(vertical)
    );
    if (results?.length > 0) {
      // Try to find "Engineering" vertical first, otherwise use the first item
      const engineeringVertical = results.find(
        (vertical: any) => vertical?.name?.toLowerCase() === "engineering"
      );
      const selectedVertical = engineeringVertical || results[0];
      
      defaultVal = {
        label: selectedVertical?.name,
        value: selectedVertical?.id,
      };
    }
    dispatch(setVerticalForKeyClauseDashboard(feat, defaultVal));
  }
};

export const getClauseCheckSummaryListData = ({
  verticalId,
  feature,
  type,
}: {
  verticalId: string | undefined;
  feature: string;
  type: string;
}) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type,
        payload: {
          feature,
          data: {
            loading: true,
            error: {},
          },
        },
      });

      const res =
        verticalId &&
        (await getClauseCheckListForSelectedVertical({ verticalId }));
      if (!res) return;
      const Model = PromptModelForClauseCheckData;
      let data = null;
      if (!Model) return;
      data = new Model({ ...res });

      dispatch({
        type,
        payload: {
          feature,
          data: {
            results: data,
            loading: false,
            error: {},
          },
        },
      });
    } catch (error: any) {
      dispatch({
        type,
        payload: {
          feature,
          data: {
            loading: false,
            error: error,
          },
        },
      });
      getToast("Error", error?.message || "Something went wrong!!");
    }
  };
};
export const getClauseCheckSummaryListDataForContractReview = ({
  verticalId,
  feature,
  type,
  isGlobal,
  contractTypeId,
}: {
  verticalId: string | undefined;
  feature: string;
  type: string;
  isGlobal?: boolean;
  contractTypeId?: string;
}) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type,
        payload: {
          feature,
          loading: true,
          error: {},
        },
      });

      const res =
        verticalId &&
        (await listContractReviewClauseManagement({
          verticalId,
          isGlobal,
          contractTypeId,
        }));
      if (!res) return;
      const Model = PromptModelForContractReview;
      let data = null;
      if (!Model) return;
      const sanitizer = getClauseItemsForContractReview;
      data = res?.clauses?.map(
        (res: any) => new Model({ ...res, sanitizer: sanitizer })
      );

      dispatch({
        type,
        payload: {
          feature: feature,
          data,
          loading: false,
          error: {},
        },
      });
    } catch (error: any) {
      dispatch({
        type,
        payload: {
          feature: feature,
          loading: false,
          error: {},
        },
      });
      getToast("Error", error?.message || "Something went wrong!!");
    }
  };
};

export const updateClause = ({
  feature,
  clauseId,
  name,
  value,
  isDefaultVal,
  vertical_id,
  displayName,
  isEnabled,
  isGlobal,
  isGlobalClause,
  contractTypeId,
  severity,
  ruleDescription,
  useOverridePrompt,
  overrideAiPrompt,
}: {
  feature: string;
  clauseId: string;
  name: string;
  value: string;
  isDefaultVal: boolean;
  vertical_id: string;
  displayName: string;
  isEnabled: boolean;
  isGlobal?: boolean;
   // Per-clause isGlobal value, falls back to view-level isGlobal when absent
  isGlobalClause?: boolean;
  contractTypeId?: string;
  severity?: string;
  ruleDescription?: string;
  // Env-gated escape hatch: loose-coupled, only present when REACT_APP_REDLINING_ENABLE_MANUAL_PROMPT=true.
  // useOverridePrompt is the toggle-state boolean; overrideAiPrompt is the raw text.
  useOverridePrompt?: boolean;
  overrideAiPrompt?: string;
}) => {
  return async (dispatch: any, getState: any) => {
    try {
      await dispatch({
        type: ADMIN_ACTIONS.UPDATE_CLAUSE,
        payload: {
          feature: feature,
          clauseId: clauseId,
          name: name,
          value: value,
        },
      });

      const featureData =
        getState()?.rootReducer?.adminReducer?.[feature]?.data?.slice();
      const clauseIdx = featureData?.findIndex(
        (prompt: any) => prompt?.id === clauseId
      );

      if (clauseIdx === -1) {
        getToast("Error", "No changes to save");
        return;
      }

      const currentClause = featureData[clauseIdx];
      const rulesCopy = currentClause?.rules?.slice() || [];

      const hasRuleDescriptionChange =
        typeof ruleDescription === "string" &&
        ruleDescription !== currentClause?.ruleDescription;

      const rulesForSave = hasRuleDescriptionChange
        ? (ruleDescription as string)
        : (currentClause?.ruleDescription ?? "");

      await saveContractReviewClauseManagement({
        clause_id: clauseId,
        rules: rulesForSave,
        vertical_id,
        display_name: displayName,
        is_enabled: isEnabled,
        // Use explicitly provided severity when available, otherwise fall back to existing value
        severity:
          typeof severity === "string"
            ? severity
            : featureData[clauseIdx]?.severity,
        // Persist global/vertical scope based on clause-level toggle when provided
        is_global:
          typeof isGlobalClause === "boolean" ? isGlobalClause : isGlobal,
        use_override_prompt: useOverridePrompt === true ? true : undefined,
        override_ai_prompt: overrideAiPrompt,
      });
      await executeAllClauseFunctions({
        keys: [adminClauseCheckConstants.CONTRACT_REVIEW_CLAUSE_LIST],
        verticalId: vertical_id,
        dispatch,
        isGlobal,
        contractTypeId,
      });
      if (!hasRuleDescriptionChange && isDefaultVal) {
        getToast("Error", "Clause couldn't be updated");
      } else {
        getToast("Success", "Clause updated successfully");
      }
    } catch (error) {
      getToast("Error", "Clause couldn't be updated");
    }
  };
};

export const addContractReviewClause = ({
  vertical_id,
  displayName,
  category,
  ruleDescription,
  isEnabled,
  isGlobal,
  contractTypeId,
  severity,
  useOverridePrompt,
  overrideAiPrompt,
}: {
  vertical_id: string;
  displayName: string;
  category?: string;
  ruleDescription?: string;
  isEnabled?: boolean;
  isGlobal?: boolean;
  contractTypeId?: string;
  severity?: string;
  useOverridePrompt?: boolean;
  overrideAiPrompt?: string;
}) => {
  return async (dispatch: any, getState: any) => {
    try {
      const featureKey =
        PromptsForFeature.CONTRACT_REVIEW_TAB
          .CONTRACT_REVIEW_CLAUSE_CHECK_LIST;
      const existingData =
        getState()?.rootReducer?.adminReducer?.[featureKey]?.data || [];
      // Reuse category from an existing clause if available, otherwise default,
      // but allow explicit category from UI to override.
      const derivedCategory =
        category || existingData[0]?.category || "General";

      const derivedIsEnabled =
        typeof isEnabled === "boolean" ? isEnabled : true;

      await createContractReviewClause({
        vertical_id,
        display_name: displayName,
        category: derivedCategory,
        rule_description: ruleDescription ?? "",
        is_enabled: derivedIsEnabled,
        is_global: !!isGlobal,
        contract_type_id: !isGlobal ? contractTypeId : undefined,
        severity,
        use_override_prompt: useOverridePrompt === true ? true : undefined,
        override_ai_prompt: overrideAiPrompt,
      });

      await executeAllClauseFunctions({
        keys: [
          adminClauseCheckConstants.CONTRACT_REVIEW_CLAUSE_LIST,
          adminClauseCheckConstants.IMPORT_CONTRACT_REVIEW_CLAUSE_CHECK_LIST,
        ],
        verticalId: vertical_id,
        dispatch,
        isGlobal: false,
        contractTypeId,
      });

      getToast("Success", "Clause added successfully");
    } catch (error: any) {
      getToast(
        "Error",
        error?.response?.data?.status_message ||
          error?.response?.data?.error ||
          "Clause couldn't be added"
      );
    }
  };
};

export const addNewKeywordSectionForTTC = () => {
  return async (dispatch: any) => {
    try {
      const newPrompt = {
        Word: "",
        Synonyms: [],
        type: defaultClauseStatus.NEW_KEYWORD,
        id: new Date().getTime(),
      };

      dispatch({
        type: ADMIN_ACTIONS.ADD_NEW_KEYWORD_SECTION_FOR_TTC,
        payload: {
          prompt: newPrompt,
        },
      });
    } catch (error) {}
  };
};

export const saveSynonym = () => {
  return async (dispatch: any, getState: any) => {
    try {
      const featureData =
        getState()?.rootReducer?.adminReducer?.[
          PromptsForFeature.TALK_TO_CONTRACT
        ]?.data?.slice();

      const ruleData = featureData[0];

      await saveTalkToContractClauseManagement({
        clause_id: ruleData?.id,
        rules: getRuleForSavingForTTC(ruleData?.rules),
      });
    } catch (error) {}
  };
};

export const saveNewSynonym = ({
  idx,
  data,
}: {
  idx: number;
  data: {
    Word: string;
    Synonyms: Array<string>;
    type: string;
  };
}) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: ADMIN_ACTIONS.SAVE_NEW_SYNONYM_FOR_TTC,
        payload: {
          idx: idx,
          data: data,
        },
      });
      await dispatch(saveSynonym());
      getToast("Success", "Keyword added successfully");
    } catch (error) {
      getToast("Error", "Keyword couldn't be added");
    }
  };
};
export const saveNewClauseCheck = async (
  payload: any,
  dispatch: any,
  setAddClauseRequestLoading: Dispatch<SetStateAction<boolean>>,
  setOpenAddClauseInputModal: Dispatch<SetStateAction<boolean>>,
  refetchClauseListData: any,
  setErrorMessage: Dispatch<SetStateAction<object>>,
  onSuccess?: () => void,
  onError?: (error: any) => void
) => {
  setAddClauseRequestLoading(true);
  try {
    dispatch({
      type: ADMIN_ACTIONS.ADD_NEW_CLAUSE_CHECK,
      payload,
    });
    await addClauseCheckDetails(payload);
    setAddClauseRequestLoading(false);
    setOpenAddClauseInputModal(false);
    refetchClauseListData();
    if (onSuccess) {
      // Delay to ensure modal closes before showing sync info
      setTimeout(() => {
        onSuccess();
      }, 100);
    } else {
      getToast("Success", "Clause added successfully");
    }
  } catch (error: any) {
    setAddClauseRequestLoading(false);
    setOpenAddClauseInputModal(true);
    if ((error?.response?.status === 409 || error?.response?.status === 503) && onError) {
      onError(error);
    } else {
      setErrorMessage(error?.response?.data);
      getToast(
        "Error",
        error?.response?.data?.status_message || "Clause couldn't be added"
      );
    }
  }
};
export const importNewClauseCheckActionHandler = async (
  payload: any,
  dispatch: any,
  setImportClauseLoading: Dispatch<SetStateAction<boolean>>,
  setOpenImportClauseModal: Dispatch<SetStateAction<boolean>>,
  resetState: any
) => {
  setImportClauseLoading(true);
  try {
    await addImportClauseCheckDetails(payload);
    setImportClauseLoading(false);
    setOpenImportClauseModal(false);
    dispatch(
      getClauseCheckSummaryListData({
        verticalId: payload?.current_vertical_id,
        feature: PromptsForFeature.CLAUSE_CHECK_TAB.CLAUSE_CHECK,
        type: ADMIN_ACTIONS.GET_CLAUSE_CHECK_SUMMARY,
      })
    );
    getToast("Success", "Clause added successfully");
    resetState();
  } catch (error: any) {
    setImportClauseLoading(false);
    setOpenImportClauseModal(true);
    getToast(
      "Error",
      error?.response?.data?.status_message || "Clause couldn't be added"
    );
  }
};
export const importNewContractReviewActionHandler = async (
  payload: any,
  dispatch: any,
  setImportClauseLoading: Dispatch<SetStateAction<boolean>>,
  setOpenImportClauseModal: Dispatch<SetStateAction<boolean>>,
  resetState: any
) => {
  setImportClauseLoading(true);
  try {
    await addImportContractReviewDetails(payload);
    setImportClauseLoading(false);
    setOpenImportClauseModal(false);
    dispatch(
      getClauseCheckSummaryListDataForContractReview({
        verticalId: payload?.destination_vertical_id,
        feature:
          PromptsForFeature.CONTRACT_REVIEW_TAB
            .CONTRACT_REVIEW_CLAUSE_CHECK_LIST,
        type: ADMIN_ACTIONS.GET_CLAUSE_CHECK_SUMMARY_FOR_CONTRACT_REVIEW,
        // Imported rules are always vertical-scoped for now
        isGlobal: false,
        contractTypeId: payload?.destination_contract_type_id,
      })
    );
    getToast("Success", "Clause imported successfully");
    resetState();
  } catch (error: any) {
    setImportClauseLoading(false);
    setOpenImportClauseModal(true);
    getToast(
      "Error",
      error?.response?.data?.status_message || "Clause couldn't be imported"
    );
  }
};

export const enableDisableClauseCheck = async (
  payload: EnableDisableClauseCheckPayloadinterface,
  dispatch: Dispatch<any>,
  setEnableDisableClauseLoading: Dispatch<SetStateAction<boolean>>,
  openEnableDisableModal: EnableDisableModalStateinterface,
  setEnableDisableModal: Dispatch<SetStateAction<any>>,
  setIsSelectedSubclause?: Dispatch<SetStateAction<selectedSubClauseInterface>>
) => {
  setEnableDisableClauseLoading(true);
  try {
    const response = await enableDisableClauseCheckDetails(payload);
    setIsSelectedSubclause?.(response?.clause_details);
    setEnableDisableModal({ ...openEnableDisableModal, isTrue: false });

    if (response?.status) {
      dispatch(
        getClauseCheckSummaryListData({
          verticalId: payload.vertical_id,
          feature: PromptsForFeature.CLAUSE_CHECK_TAB.CLAUSE_CHECK,
          type: ADMIN_ACTIONS.GET_CLAUSE_CHECK_SUMMARY,
        })
      );
    }

    getToast(
      "Success",
      response?.status_message || "Clause added successfully"
    );
    setEnableDisableClauseLoading(false);
  } catch (error: any) {
    setEnableDisableClauseLoading(false);
    setEnableDisableModal({ ...openEnableDisableModal, isTrue: false });
    getToast(
      "Error",
      error?.response?.data?.status_message || "Clause couldn't be added"
    );
  }
};

export const saveClauseCheck = () => {
  return async (dispatch: any, getState: any) => {
    try {
      const featureData =
        getState()?.rootReducer?.adminReducer?.[
          PromptsForFeature.TALK_TO_CONTRACT
        ]?.data?.slice();

      const ruleData = featureData[0];

      await saveTalkToContractClauseManagement({
        clause_id: ruleData?.id,
        rules: getRuleForSavingForTTC(ruleData?.rules),
      });
    } catch (error) {}
  };
};

export const deleteKeyword = ({ id }: { id: number }) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: ADMIN_ACTIONS.DELETE_KEYWORD_SECTION_FOR_TTC,
        payload: {
          keywordId: id,
        },
      });
      await dispatch(saveSynonym());
      getToast("Success", "Keyword deleted successfully");
    } catch (error) {
      getToast("Error", "Keyword couldn't be deleted");
    }
  };
};

export const removeKeywordsWithNewKeywordType = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: ADMIN_ACTIONS.REMOVE_KEYWORDS_WITH_NEW_KEYWORD_TYPE,
      });
      await dispatch(saveSynonym());
    } catch (error) {}
  };
};

export const setDataForRoleManagement = (data: any) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: ADMIN_ACTIONS.SET_ROLE_MANAGE_DATA,
        payload: data,
      });
    } catch (err) {}
  };
};
